import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Microscope, Beaker, BookOpen, Users, LineChart, FileText, ArrowRight, Download } from 'lucide-react';
export function ResearchHub() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-2309" data-mp="1clkdrne5fb56">
      <Header data-id="element-2310" data-mp="17q52923m5rbx" />
      <main className="flex-grow" data-id="element-2311" data-mp="17pd87vpo01nr">
        {/* Hero Section */}
        <section className="relative w-full bg-gray-50" data-id="element-2312" data-mp="jyg598fukeon">
          <div className="absolute inset-0 overflow-hidden" data-id="element-2313" data-mp="jwwkp5n5rhh2">
            <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1581093588401-fbb62a02f120?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')",
            backgroundBlendMode: 'overlay'
          }} data-id="element-2314" data-mp="f1h80h0vzrm8" />
            <div className="absolute inset-0 bg-gradient-to-r from-teal-600/20 to-blue-600/20" data-id="element-2315" data-mp="3sestyca1106j" />
          </div>
          <div className="container mx-auto px-4 py-16 md:py-24 relative z-10" data-id="element-2316" data-mp="82uqhcjzt3q2">
            <div className="max-w-3xl" data-id="element-2317" data-mp="c4g08p18d1w1">
              <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4" data-id="element-2318" data-mp="gx94zcwp8a84">
                Research Hub
              </h1>
              <div className="w-20 h-1 bg-teal-600 mb-6" data-id="element-2319" data-mp="lv0vq3llxqaq"></div>
              <p className="text-lg md:text-xl text-gray-700 mb-8" data-id="element-2320" data-mp="3lb7bzzyy420b">
                Exploring the frontiers of microbiome science with
                pharmaceutical-grade rigor to validate therapeutics and wellness
                interventions.
              </p>
            </div>
          </div>
        </section>
        {/* Research Approach Section */}
        <section className="py-16 bg-white" data-id="element-2321" data-mp="375n0y4ur2oh">
          <div className="container mx-auto px-4" data-id="element-2322" data-mp="19lwtdhcqvfpw">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-2323" data-mp="19l4vfzvod5wg">
              <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-2324" data-mp="1ejyb9yyfp8zs">
                Our Research Approach
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-2325" data-mp="ov105qmp7uvq"></div>
              <p className="text-gray-600" data-id="element-2326" data-mp="jyam18ugf9cy">
                At CalMiR, we apply pharmaceutical-grade research methodologies
                to the study of microbiome science and wellness interventions.
                Our approach combines rigorous scientific methods with
                translational focus to ensure discoveries benefit real people.
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8" data-id="element-2327" data-mp="17jfsg5rjz2s">
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-2328" data-mp="14wxblhc3z5s">
                <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-2329" data-mp="fy0h7zieeozo">
                  <Microscope className="text-teal-600" size={24} data-id="element-2330" data-mp="3jl0szqh9gs4n" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2331" data-mp="3jio1allpb3ee">
                  Scientific Rigor
                </h3>
                <p className="text-gray-600" data-id="element-2332" data-mp="1u4581u0v8ace">
                  We employ controlled experiments, double-blind studies, and
                  statistical validation to ensure our findings meet the highest
                  scientific standards.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-2333" data-mp="1p4sbuio3tqx5">
                <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-2334" data-mp="2cud4xudz24k5">
                  <LineChart className="text-teal-600" size={24} data-id="element-2335" data-mp="2htzlodt0e2xp" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2336" data-mp="23tyk0w4x6rh6">
                  Data-Driven Insights
                </h3>
                <p className="text-gray-600" data-id="element-2337" data-mp="27u8q08spphw1">
                  Advanced computational modeling and biomarker analysis inform
                  our understanding of complex microbiome interactions and
                  therapeutic potentials.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-2338" data-mp="1cnrldyd7h6p0">
                <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-2339" data-mp="17w9i33npmu0v">
                  <Users className="text-teal-600" size={24} data-id="element-2340" data-mp="12yhq69n2f7wo" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2341" data-mp="xz4tyyab0ohf">
                  Translational Focus
                </h3>
                <p className="text-gray-600" data-id="element-2342" data-mp="1vllpbxzh8s0j">
                  We prioritize research with clear paths to real-world
                  applications, ensuring discoveries translate into improved
                  health outcomes.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Research Pipeline */}
        <section className="py-16 bg-gray-50" data-id="element-2343" data-mp="a8iz68pb90pd">
          <div className="container mx-auto px-4" data-id="element-2344" data-mp="aac7dsfknszh">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-2345" data-mp="67fglefvoqkg">
              <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-2346" data-mp="69a4n1mg4ysr">
                Research Pipeline
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-2347" data-mp="2lw4bqagypxlx"></div>
              <p className="text-gray-600" data-id="element-2348" data-mp="2lwe424phcgus">
                Our comprehensive research pipeline takes discoveries from
                initial hypothesis through validation to real-world
                implementation.
              </p>
            </div>
            <div className="relative" data-id="element-2349" data-mp="30ltpr6a5lw3m">
              {/* Pipeline Steps */}
              <div className="hidden md:block absolute top-1/2 left-0 right-0 h-1 bg-teal-200 transform -translate-y-1/2 z-0" data-id="element-2350" data-mp="35jv81ozr9re1"></div>
              <div className="grid md:grid-cols-4 gap-8 relative z-10" data-id="element-2351" data-mp="39mrx9yjswlqy">
                <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2352" data-mp="3ekjpktocy9vo">
                  <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4 mx-auto" data-id="element-2353" data-mp="1f8h7nnvdtnk4">
                    <div className="text-teal-600" size={24} data-id="element-2354" data-mp="1k7k3qitdwjfy" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2 text-center" data-id="element-2355" data-mp="2nipos100xaio">
                    Discovery
                  </h3>
                  <p className="text-gray-600 text-sm text-center" data-id="element-2356" data-mp="2iko9lr5pxvch">
                    Initial hypothesis formation and bench research to identify
                    promising interventions.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2357" data-mp="36g0p7oxe69zp">
                  <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4 mx-auto" data-id="element-2358" data-mp="31i8xauwqynvi">
                    <Beaker className="text-teal-600" size={24} data-id="element-2359" data-mp="3f8ceh7grrre3" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2 text-center" data-id="element-2360" data-mp="3b8k2eks6333z">
                    Validation
                  </h3>
                  <p className="text-gray-600 text-sm text-center" data-id="element-2361" data-mp="3p4xgrl1emoe8">
                    Rigorous testing through in vitro, animal models, and
                    preliminary human studies.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2362" data-mp="cnz8ubkfssi5">
                  <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4 mx-auto" data-id="element-2363" data-mp="3twci5a8dpec4">
                    <Users className="text-teal-600" size={24} data-id="element-2364" data-mp="2nosii33v4yr" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2 text-center" data-id="element-2365" data-mp="3l2h8pq0851qo">
                    Clinical Trials
                  </h3>
                  <p className="text-gray-600 text-sm text-center" data-id="element-2366" data-mp="3pvsl06nt2apz">
                    Controlled human studies to confirm efficacy, safety, and
                    optimal protocols.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2367" data-mp="323v8segg1goc">
                  <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4 mx-auto" data-id="element-2368" data-mp="364x8ewe9vuqu">
                    <BookOpen className="text-teal-600" size={24} data-id="element-2369" data-mp="3mkzf32cos6fj" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2 text-center" data-id="element-2370" data-mp="3hnpr7r4y42tt">
                    Implementation
                  </h3>
                  <p className="text-gray-600 text-sm text-center" data-id="element-2371" data-mp="3cp4nviued315">
                    Translation into protocols, products, and educational
                    resources for real-world impact.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Current Research Focus */}
        <section className="py-16 bg-white" data-id="element-2372" data-mp="2txved9kmme9k">
          <div className="container mx-auto px-4" data-id="element-2373" data-mp="2tuhc01byq524">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-2374" data-mp="2oys8jmwto40j">
              <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-2375" data-mp="2jyedd5gbkojx">
                Current Research Focus
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-2376" data-mp="2fy3vauf967op"></div>
              <p className="text-gray-600" data-id="element-2377" data-mp="vfa4qf1qhbn8">
                Our research teams are currently focused on several key areas
                with significant potential for advancing microbiome science and
                therapeutic applications.
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-8" data-id="element-2378" data-mp="14dvky3jqgeku">
              <div className="bg-gray-50 p-8 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-2379" data-mp="19dgkaf2teoy3">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-2380" data-mp="bsc8xjrb3b4t">
                  Microbiota Reset Protocols
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-2381" data-mp="gnrg5sut68s9">
                  Developing and validating structured interventions to restore
                  healthy microbiome balance after disruption from antibiotics,
                  illness, or lifestyle factors.
                </p>
                <ul className="text-gray-600 space-y-2 mb-4" data-id="element-2382" data-mp="3p5no8w5xxlg5">
                  <li className="flex items-start" data-id="element-2383" data-mp="3u3yvr08rjjv7">
                    <span className="text-teal-600 mr-2" data-id="element-2384" data-mp="3u2ntx5yvom6q">•</span>
                    <span data-id="element-2385" data-mp="4b1vhln455b6">Targeted prebiotic/probiotic combinations</span>
                  </li>
                  <li className="flex items-start" data-id="element-2386" data-mp="99d3dqtul5qr">
                    <span className="text-teal-600 mr-2" data-id="element-2387" data-mp="ea0u0be5zkkg">•</span>
                    <span data-id="element-2388" data-mp="eaiwvqvc0x1c">Dietary intervention protocols</span>
                  </li>
                  <li className="flex items-start" data-id="element-2389" data-mp="j8c4moca9z3q">
                    <span className="text-teal-600 mr-2" data-id="element-2390" data-mp="3hqq3o691naec">•</span>
                    <span data-id="element-2391" data-mp="3hodcr3lb5pp5">Personalized microbiome recovery strategies</span>
                  </li>
                </ul>
                <a href="/research-hub/microbiota-reset" className="inline-flex items-center text-teal-600 hover:text-teal-700 transition-colors duration-200" data-id="element-2392" data-mp="3ronpkn3fkv3s">
                  Learn more about this research
                  <ArrowRight size={16} className="ml-1" data-id="element-2393" data-mp="2yzgqnn02e3i0" />
                </a>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-2394" data-mp="33xicugsseixp">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-2395" data-mp="1l35pxvjsuev1">
                  Gut Barrier & Immune Signaling
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-2396" data-mp="1c30glfv1p6e8">
                  Investigating the relationship between microbiome composition,
                  intestinal barrier function, and immune system regulation.
                </p>
                <ul className="text-gray-600 space-y-2 mb-4" data-id="element-2397" data-mp="1264hu1uy7ymv">
                  <li className="flex items-start" data-id="element-2398" data-mp="xee4dn0psur8">
                    <span className="text-teal-600 mr-2" data-id="element-2399" data-mp="xct8nu2nz5rs">•</span>
                    <span data-id="element-2400" data-mp="tc9d2uxqoa7r">Tight junction protein expression</span>
                  </li>
                  <li className="flex items-start" data-id="element-2401" data-mp="ody3mlbcw1q2">
                    <span className="text-teal-600 mr-2" data-id="element-2402" data-mp="of9348xrqnbd">•</span>
                    <span data-id="element-2403" data-mp="jeuxsynjxrh1">
                      Microbial metabolite influence on barrier integrity
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-2404" data-mp="ehl7zhw93dso">
                    <span className="text-teal-600 mr-2" data-id="element-2405" data-mp="4quuwy3ro8k2">•</span>
                    <span data-id="element-2406" data-mp="9qze4vw27hdz">Inflammatory pathway modulation</span>
                  </li>
                </ul>
                <a href="/research-hub/gut-barrier" className="inline-flex items-center text-teal-600 hover:text-teal-700 transition-colors duration-200" data-id="element-2407" data-mp="3rwvjcyqhbknk">
                  Learn more about this research
                  <ArrowRight size={16} className="ml-1" data-id="element-2408" data-mp="nj5sqdjkdgbb" />
                </a>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-2409" data-mp="sgp6lcccnr2q">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-2410" data-mp="eptvruiaizwi">
                  Biomarker Discovery
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-2411" data-mp="16h9rce1trwyv">
                  Identifying and validating biomarkers that predict microbiome
                  health, therapeutic response, and clinical outcomes.
                </p>
                <ul className="text-gray-600 space-y-2 mb-4" data-id="element-2412" data-mp="2vxlqujtd388c">
                  <li className="flex items-start" data-id="element-2413" data-mp="2vw0xgxis9vc2">
                    <span className="text-teal-600 mr-2" data-id="element-2414" data-mp="2qy921tixjr34">•</span>
                    <span data-id="element-2415" data-mp="35nx5p1el31u0">Microbiome diversity metrics</span>
                  </li>
                  <li className="flex items-start" data-id="element-2416" data-mp="35q1bxpzygcxg">
                    <span className="text-teal-600 mr-2" data-id="element-2417" data-mp="30qewd9wnmklh">•</span>
                    <span data-id="element-2418" data-mp="2cz9jn3m0g8fe">Metabolomic signatures</span>
                  </li>
                  <li className="flex items-start" data-id="element-2419" data-mp="2d1cec0y3ypqg">
                    <span className="text-teal-600 mr-2" data-id="element-2420" data-mp="281q3fy5r5lkt">•</span>
                    <span data-id="element-2421" data-mp="2mxfjlfo9b4hm">Host-microbe interaction markers</span>
                  </li>
                </ul>
                <a href="/research-hub/biomarkers" className="inline-flex items-center text-teal-600 hover:text-teal-700 transition-colors duration-200" data-id="element-2422" data-mp="2hy2u0n603jbc">
                  Learn more about this research
                  <ArrowRight size={16} className="ml-1" data-id="element-2423" data-mp="3tfvl9xl2fjcy" />
                </a>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-2424" data-mp="22yqlo0g36t08">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-2425" data-mp="27xuvmtau4urm">
                  Global Microbiome Diversity
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-2426" data-mp="2gwyepxa05a64">
                  Studying microbiome variations across global populations to
                  understand cultural, dietary, and environmental influences on
                  microbiome health.
                </p>
                <ul className="text-gray-600 space-y-2 mb-4" data-id="element-2427" data-mp="2qs9t2ehi0fdc">
                  <li className="flex items-start" data-id="element-2428" data-mp="2vmmeuv6g62s9">
                    <span className="text-teal-600 mr-2" data-id="element-2429" data-mp="2zmoj9c3khab8">•</span>
                    <span data-id="element-2430" data-mp="2zm4xtlepk3sg">Cross-cultural microbiome comparison</span>
                  </li>
                  <li className="flex items-start" data-id="element-2431" data-mp="34nkivdgvyaau">
                    <span className="text-teal-600 mr-2" data-id="element-2432" data-mp="39kkrnw54dr5n">•</span>
                    <span data-id="element-2433" data-mp="39izudyrf7u43">Traditional dietary practice assessment</span>
                  </li>
                  <li className="flex items-start" data-id="element-2434" data-mp="3jmy5t8833qow">
                    <span className="text-teal-600 mr-2" data-id="element-2435" data-mp="3epoipz863r48">•</span>
                    <span data-id="element-2436" data-mp="39qv6sb8j4866">Adaptable intervention development</span>
                  </li>
                </ul>
                <a href="/research-hub/global-diversity" className="inline-flex items-center text-teal-600 hover:text-teal-700 transition-colors duration-200" data-id="element-2437" data-mp="35pjc3rasswr4">
                  Learn more about this research
                  <ArrowRight size={16} className="ml-1" data-id="element-2438" data-mp="1btjj0kboic8" />
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* Publications Section */}
        <section className="py-16 bg-gray-50" data-id="element-2439" data-mp="3onm8ws9l7xzh">
          <div className="container mx-auto px-4" data-id="element-2440" data-mp="p0dvymabgmmo">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-2441" data-mp="p274y88ejixu">
              <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-2442" data-mp="k9nqza5sylsi">
                Publications & Findings
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-2443" data-mp="2ei9q5no9abhg"></div>
              <p className="text-gray-600" data-id="element-2444" data-mp="2jh45ugqxfjxc">
                Our research is regularly published in peer-reviewed journals
                and presented at scientific conferences. Below are some of our
                recent publications.
              </p>
            </div>
            <div className="space-y-6 max-w-4xl mx-auto" data-id="element-2445" data-mp="1vr9vq6xzs9gs">
              {[{
              title: 'Standardized Microbiota Reset Protocol Improves Gut Barrier Function in Healthy Adults: A Randomized Controlled Trial',
              authors: 'Chen J, Patel S, Nguyen T, et al.',
              journal: 'Journal of Microbiome Research',
              year: '2023',
              doi: '10.1234/jmr.2023.01.001'
            }, {
              title: 'Comparative Analysis of Probiotic Strains for Post-Antibiotic Microbiome Recovery',
              authors: 'Martinez R, Johnson K, Williams A, et al.',
              journal: 'Frontiers in Microbiology',
              year: '2022',
              doi: '10.3389/fmicb.2022.12345'
            }, {
              title: 'Biomarkers of Intestinal Permeability: Correlation with Microbiome Composition and Clinical Outcomes',
              authors: 'Lee H, Garcia D, Smith P, et al.',
              journal: 'Nature Communications',
              year: '2022',
              doi: '10.1038/s41467-022-12345-6'
            }, {
              title: 'Traditional Fermentation Practices Across African Communities: Implications for Microbiome Health',
              authors: 'Okafor N, Mbeki L, Adeyemi O, et al.',
              journal: 'Science Advances',
              year: '2021',
              doi: '10.1126/sciadv.abc1234'
            }].map((publication, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2446" data-mp="3d4k1r6gt0aml" data-mpi={index}>
                  <div className="flex items-start" data-id="element-2447" data-mp="3mwy3hz7vth8r">
                    <div className="mt-1" data-id="element-2448" data-mp="3rw2coput3ez3">
                      <FileText className="text-teal-600" size={20} data-id="element-2449" data-mp="3ruzo4okyhomc" />
                    </div>
                    <div className="ml-4" data-id="element-2450" data-mp="2u9bq5z8uqy8p">
                      <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-2451" data-mp="2z6vho0uk97il">
                        {publication.title}
                      </h3>
                      <p className="text-gray-600 mb-1" data-id="element-2452" data-mp="3455cubgac847">
                        {publication.authors}
                      </p>
                      <p className="text-gray-500 text-sm mb-2" data-id="element-2453" data-mp="392yhh01xwu2d">
                        {publication.journal}, {publication.year} | DOI:{' '}
                        {publication.doi}
                      </p>
                      <a href={`/publications/${publication.doi}`} className="inline-flex items-center text-teal-600 hover:text-teal-700 transition-colors duration-200 text-sm" data-id="element-2454" data-mp="ogn6jzpjtpj8">
                        View publication
                        <Download size={14} className="ml-1" data-id="element-2455" data-mp="1z4ys96lx0jzb" />
                      </a>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="text-center mt-10" data-id="element-2456" data-mp="1pa6p7n9kd4x5">
              <a href="/research-hub/publications" className="px-6 py-3 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors duration-200 shadow-sm inline-flex items-center" data-id="element-2457" data-mp="1l6quiwh21en3">
                View All Publications
                <ArrowRight size={16} className="ml-2" data-id="element-2458" data-mp="3am6wnrwka03h" />
              </a>
            </div>
          </div>
        </section>
        {/* Collaboration CTA */}
        <section className="py-16 bg-teal-600 text-white" data-id="element-2459" data-mp="35nn59bz77w3q">
          <div className="container mx-auto px-4" data-id="element-2460" data-mp="1cbvnba6jipi">
            <div className="max-w-3xl mx-auto text-center" data-id="element-2461" data-mp="1dvdv7fec3tx">
              <h2 className="text-3xl font-bold mb-4" data-id="element-2462" data-mp="3sj4vobt8lbsg">Collaborate With Us</h2>
              <p className="text-teal-100 mb-8" data-id="element-2463" data-mp="3nqvaf932gzwi">
                We welcome collaboration with researchers, clinicians, and
                organizations who share our commitment to advancing microbiome
                science with rigor and integrity.
              </p>
              <div className="flex flex-wrap justify-center gap-4" data-id="element-2464" data-mp="3eocaoxukv3eh">
                <a href="/contact" className="px-6 py-3 bg-white text-teal-600 rounded-md hover:bg-gray-100 transition-colors duration-200 shadow-sm" data-id="element-2465" data-mp="39q10un4a8sw9">
                  Contact Our Research Team
                </a>
                <a href="/research-hub/partnerships" className="px-6 py-3 bg-teal-700 text-white border border-teal-400 rounded-md hover:bg-teal-800 transition-colors duration-200 shadow-sm" data-id="element-2466" data-mp="131ea0se4wrh4">
                  Learn About Partnerships
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-2467" data-mp="1favkcey938hv" />
    </div>;
}